// src/lang/zh_CN.js
const zh_CN = {
  truck:{
    type:"仓库类型",
    cityOrZip:"仓库邮编/城市",
    containerSize:"箱型",
    type2:"箱型",
    PortOfDischarge:"卸货港",
    getPrice:"获取卡车报价!",
    thirdPart:"第三方",
    amazon:"亚马逊",
    FBACode:"仓库代码",
    distance:"直线距离",
    from:"卸货港",
    to:"目的地",
    mileage:"卡车里程",
    phone:"联系电话",
    loading:"查询中",
    total:"合计",
    endTime:"有效期",
    tit:"联系客服即可下单",
    tit2:"以上后段直送费用不含",
    tit3:"说明",
    tit4:"如遇拒收的方案",
    dan:"请单询",
    dan2:"派送距离较长，请单询",
    more:"更多功能请用电脑访问",
    
    explan:{
      e1:"LIVE LOAD送货：待时费USD85/小时，前1小时免费（若派送后三个工作日内无法提供凭证，最高按照USD255收取）",
      e2:"超重费：USD350/整柜（若20GP整柜货重超过14.5TON，需加收此费用；20GP整柜货重不能超过17TON。若40HQ整柜货重超过19TON，需加收此费用；40HQ整柜货重不能超过21TON）",
      e3:"车架分离费：实报实销（靠LBCT码头或铁路站，20GP/45HQ/40冷柜会有此费用）码头费/查验费/税金/过夜费：实报实销",
      e4:"TSCA/PPQ/FDA申报费：USD50/次",
      e5:"所有植物、木头需要申报PPQ",
      e6:"所有复合木成分的产品、木质类的（只要不是纯实木）、所有化学成分产品需要申报TSCA",
      e7:"所有与人体接触的食品、药品等品名需要申报FDA",
      e8:"1、超重费: USD 350/40 GP&HQ, 重量：超过19吨，但不大于20.8吨。超过20.8吨，需单票核实。有可能无法承接。 ",
      e9:"2、异地还车架费 $100 （20' & 45' & LBCT& reefer container will apply）",
      e10:"3、箱型：冷代干 不能用于亚马逊直送",
      e11:"方案1 ：送回卡车堆场，等有新的约后再次整柜直送。 派送费 + YARD STORAGE USD 55/DAYS",
      e12:"方案2 ：送回我司仓库，转为拆柜打托派送。拆柜费+ 进出库费 USD 15/PLTS + 整车派送费",
      e13:"方案3 ：让司机原地等待，等有当天的新约后，再次check in。 收取待时费。",
    },
    pls:{
      city:"支持邮编&城市名",
        FBACode:"请输入亚马逊仓库代码",
        PortOfDischarge:"请选择卸货港",
        phone:"请输入手机号码或邮箱",
    },
    notic:{
      contact:"联系方式不能为空！",
      success:"发送成功！",
      error:"邮箱或手机号格式不正确！",
      null:"未查询到该仓库或卸货港信息！",
      null2:"该点我司暂不支持整柜直送，请联系客服单询！"
    },
    table:{
      details:"费用明细",
      name:"费用名称",
      amount:"金额 $",
      remark:"备注",
      clearance:"清关费",
      terminal:"码头附加费",
      chassis:"车架费",
      delivery:"送货费",
      prePull:"预提费",
      storag:"卡车堆场仓储费",
      deliveryAll:"直送全包费用",
      carrier:"换单费",
      bill:"每票",
      e1:"$50/天，最少三天",
      e2:"含燃油附加费",
      e3:"原因：LFD/仓库收货/码头关闭",
      e4:"每天",
      e5:"车队/仓库要求",
      expirationDate:"有效期",

    },
    btn:{
      send:"发送",
    }
  },

  desc: {
    notice:'提示',
    deleteMsg: '确定要删除这条数据吗?',
    portOfOri: '起运港委托',
    portOfDes: '目的港发起',
    toConfirm: '待确认',
    feeItem: '请选择费用分类',
    feeCharge: '请选择或输入费用名称',
    amount: '费用金额不能为0和负数',
    confirmDelete: '是否确认删除',
    delete: '此操作将永久删除该记录, 是否继续?',
    deSuc: '删除成功',
    sedSuc: '发送成功',
    savSuc: '保存成功',
    upSuc: '上传成功',
    copySuc: '复制成功',
    select: '请先选择数据项',
    prompt: "提示",
    downFile: '下载文件',
    house: '新建House单',
    AHouse: '添加House单',
    saveDraft: '确定要保存为草稿吗？',
    sendErr: '发送失败，请检查填写项！',
    sendErrM: '发送失败，请保存草稿并联系客服！',
    balanceNot: '余额不足,请充值！',
    one: '至少留一个',
    overTen: '您的草稿箱记录已超过十条，请及时清理',
  },
  rule: {
    name: "请输入名称",
    address: '地址必填',
    country: '请选择国家',
    city: '城市必填',
    cityEr: '城市含非法字符',
    nameEr: '名称含非法字符',
    adrEr: '地址含非法字符',
    excel: '上传文件只能是 xls、xlsx格式',
    max10MB: '文件大小不能超过 10MB!',
    upEr: '上传失败，请检查表格填写是否正确',
    house: 'House单没有填写内容！',
    errorRule: '含非法字符(注意非法不可见字符)',
    upAndNotSpc: '大写字符和数字，不能有空格',
    max3mi: '不超过3位小数',
    max5: '最多5位字符',
    max10: '最多10位字符',
    max12: '最多12位字符',
    max14: '最多14位字符',
    max15: '最多15位字符',
    j6: '只能是6位数字',
    Mnu: '请输入正整数',
    shipCompany: '请选择船公司',
    mbl: '船东提单号必填',
    mblDuplicated:"船公司SCAC CODE 填写重复",
    vesse: '船名必填',
    voyage: '船次必填',
    place: '请选择发货地',
    loadingPort: '请选择装货港',
    dischargePort: '请选择卸货港',
    SCACCODE: '',
    etd: '请选择预计出发时间',
    eta: '选择预计到达时间',
    hbl: '货代提单号必填',
    containerNo: '箱号必填',
    containerSign:'',
    sealNo: '封号必填',
    containerType: '请选择箱型',
    description: '品名必填',
    marks: '唛头必填',
    packageCartons: '件数必填',
    packageType: '请选择包装单位',
    grossWeight: '毛重必填',
    CBM: '体积必填',
    noSeal: '提示：如没有封号，请填大写的 NOSEAL',
    shpper: '提示：请务必填写真实发货人信息，否则，被目的港退回、产生罚款等后果由用户自行承担。',
    consignee: '提示：请务必填写真实收货人信息，否则，被目的港退回、产生罚款等后果由用户自行承担。',
    notify: '提示：请务必填写真实通知人信息，否则，被目的港退回、产生罚款等后果由用户自行承担。',
    underNow: '必须晚于今天',
    aUnderd: '预计到达日期 必须晚于 预计出发日期',
    min1: '请至少保留一个House单'
  },
  title: {
    login: "登录",
    title1: '美国换单控制台',
    Announcement: '湃乐多公告',
    sysAnnouncement: '系统公告'
  },


  placeholders: {
    forDate: '选择日期',
    mbl: '请输入 MBL/HBL',
    name: '企业名称',
  },
  btn: {
    Funds: '账户充值',
    sendAg: '再次发送',
    deleteBill: '删单',
    amsExport: 'AMS导出',
    saveAMs: '保存草稿',
    submitAms: '发送',
    modify: "修改",
    view: "查看",
    history: '历史',
    copy: '复制',
    delete: "删除",
    deleteList: "批量删除",
    more: "更多",
    reset: "重置",
    confirm: '确定',
    cancel: '取消',
    exportExcel: '导出电子表格',
    search: '查询',
    Voided: '作废',
    hide: '隐藏',
    hideTopic: '隐藏',
    hideBtn: '隐藏搜索',
    openTopic: '展开',
    add: '新增',
    hide: '隐藏搜索栏',
    open: '展开搜索栏',
    null: '暂无数据',
    downTep: '下载模板',
    operate: '操作',
    isf: 'ISF信息',
    ams: 'AMS导出'
  },
  label: {
    email: "邮箱",
    password: "密码",
  },
  leftBar: {
    title: '美国目的港换单',
    controller: '管理员控制台',
    send: '已委托换单',
    confirm: '待确认事项',
    fee: '目的港代收费用'
  },
  control: {
    tit1: '换单进度',
    tit2: '重要通知',
    press: '换单进行中',
    msg1: {
      msg1: '五天内到港',
      msg2: '尚未发送AN',
      msg3: '其中正本提单'
    },
    msg2: {
      msg1: 'AN已发',
      msg2: '收货人未回复'
    },
    msg3: {
      msg1: '超期',
      msg2: '未提箱'
    },
    msg4: {
      msg1: '超期',
      msg2: '未还箱'
    },
    msg5: "",
    msg6: "其他待确认",
  },
  fee: {
    title: '编辑费用',
    columns: {
      column1: '客户名称',
      column2: '创建日期',
      column3: '费用分类',
      column4: '发送AN的日期',
      column5: '实际到港日',
      column6: '费用名称',
      column7: '金额',
      column8: '收款日期',
      column9: '操作'
    }
  },
  confirm: {
    columns: {
      column1: '客户名称',
      column2: '创建日期',
      column3: '费用分类',
      column4: '待确然/已确认',
      column5: '操作'
    }
  }
};
export default zh_CN;
